module.exports = __webpack_public_path__ + "static/media/fail-black.93d4db02.svg";